import React, { type ReactElement } from 'react';

import classnames from 'classnames';
import Image from 'next/image';

import logo from '@static/node/images/sherpany-logo-full.svg';

import styles from './SherpanyTopLogo.module.scss';

type SherpanyTopLogoProps = {
    className?: string;
    width?: number;
    height?: number;
};

const SherpanyTopLogo = ({
    className,
    width = 200,
    height = 42
}: SherpanyTopLogoProps): ReactElement => {
    return (
        <div className={classnames(styles.logo, className)}>
            <Image quality={100} alt="Sherpany" src={logo} width={width} height={height} priority />
        </div>
    );
};

export default SherpanyTopLogo;
